import { combineReducers } from 'redux';

import JourneyBuilderSettings from './JourneyBuilder';

export default combineReducers({
  JourneyBuilderSettings,
});



// WEBPACK FOOTER //
// ./src/JourneyBuilder/reducers/index.js